import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  compose,
  setDisplayName,
} from 'recompose';
import {
  Nav,
  NavbarToggler,
} from 'reactstrap';

import { injectIntl } from 'components';

import {
  getSelector,
} from 'redux/selectors';
import { setSidebarOpen } from 'redux/ui/actions';
import MenuIcon from '@material-ui/icons/Menu';
import { isMobile } from 'helpers/detect-mobile';
import {
  clearCartLocalStorage,
} from 'helpers/utils';
import Button from '@material-ui/core/Button';

export class UnauthorizedHeader extends Component {
  static contextTypes = {
    brands: PropTypes.shape({}),
  };

  static propTypes = {
    accessToken: PropTypes.string,
    headerTitle: PropTypes.node,
    searchContent: PropTypes.node,
    avatar: PropTypes.node,
    setSidebarOpen: PropTypes.func.isRequired,
    history: PropTypes.shape({}),
    location: PropTypes.shape({}),
    isShopPage: PropTypes.bool,
    orderCart: PropTypes.node,
  };

  static defaultProps = {
    accessToken: null,
    headerTitle: '',
    searchContent: '',
    avatar: '',
    history: {},
    location: {},
    isShopPage: false,
    orderCart: null,
    isMarketplaceStore: false
  };

  state = {
    // notificationPopoverOpen: false,
  };

  activeRoute = (routeName) => {
    const { location } = this.props;
    return location.pathname ? location.pathname.indexOf(routeName) > -1 : false;
  }

  handleLogout = () => {
    memoryDB.tokenInfo = JSON.stringify({ data: {} });
    clearCartLocalStorage();
    window.location = '/';
  };

  render() {
    const {
      headerTitle,
      searchContent,
      avatar,
      setSidebarOpen,
      accessToken,
      isShopPage,
      orderCart,
      isMarketplaceStore
    } = this.props;
    const { brands } = this.context;

    return (
      <header
        className="app-header navbar"
        style={{
          backgroundColor: brands.navbarColor,
          color: brands.navTextColor || 'white',
          justifyContent: 'space-between',
        }}
      >
        <div className="d-flex align-items-center">
          {accessToken && (
            <NavbarToggler onClick={() => setSidebarOpen(true)}>
              <MenuIcon style={{ fill: '#4695ec' }} />
            </NavbarToggler>
          )}
          <Link to="/">
            <img
              alt="sun"
              className="home-logo"
              src={brands.logoUrl}
            />
          </Link>
          {isMarketplaceStore ? (
              <Nav navbar>
                {!isMobile && 
                  <React.Fragment>
                    <Link to="/marketplace">
                      <h3 className="header-title" style={{ marginLeft: 15 }}> Marketplace</h3>
                    </Link>
                    <h3 className="header-title" style={{ marginLeft: 15 }}>{headerTitle}</h3>
                  </React.Fragment>
                }
              </Nav>  
            ) : (
              !isMobile && (
                <Nav navbar>
                  <h3 className="header-title" style={{ marginLeft: 15 }}>{headerTitle}</h3>
                </Nav>
              )
            )}
         
          {searchContent}
        </div>
        {!isShopPage && (
          <div className="nav-avatar">
            {avatar}
          </div>
        )}
        {!accessToken && (
            <div>
              <Button
                style={{marginRight:isMobile ? 20 : 30}}
                variant="contained" 
                color="primary"
                component={ Link } to="/#login"
              >
              Log in
              </Button>
              <Button
                style={{marginRight:isMobile ? 10 : 50}}
                variant="contained" 
                color="primary"
                component={ Link } to="/#signup"
              >
              Sign Up
              </Button>
            </div>
          )}
        {isShopPage && (
          <div className="header-nav-right">
            <div className={`nav-avatar`}>
              {avatar}
            </div>
          </div>
        )}
      </header>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  searchContent: getSelector('ui', 'searchContent')(state),
  orderCart: getSelector('ui', 'orderCart')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  setSidebarOpen: open => dispatch(setSidebarOpen(open)),
});

export default compose(
  setDisplayName('UnauthorizedHeader'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
)(UnauthorizedHeader);
